import { render, staticRenderFns } from "./ModalQuotation.vue?vue&type=template&id=605f7ff6&lang=pug&"
import script from "./ModalQuotation.vue?vue&type=script&lang=js&"
export * from "./ModalQuotation.vue?vue&type=script&lang=js&"
import style0 from "./ModalQuotation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports